<template>
  <div class="project item">
    <div class="container custom">
      <div class="project__content single">
        <div class="project__content-breadcrumb" data-aos="fade">
          <el-breadcrumb separator="/">
            <template v-for="(item, index) in routeList">
              <el-breadcrumb-item v-if="item.meta.title" :key="index" :to="{ name: item.name }">
                {{ item.meta.title }}
              </el-breadcrumb-item>
            </template>
          </el-breadcrumb>
        </div>
        <div class="project__content-title" data-aos="fade-up">Timebird Exchange</div>
        <div class="project__content-subtitle" data-aos="fade-up">A crypto exchange fiiting to diversified projects</div>
        <div class="project__content-text" data-aos="fade-up">Acquire knowledge from the model of Vietnam Stock Market, TimeBird has developed the Cloud Exchange Network System (CENS) which provides diversified features for traders, brokers and operators. Either building an exchange or increasing number of traders/orders becomes faster compared to usual with reasonable cost. Moreover, TimeBird’s applied the multi-tier architecture system and eKYC on CENS. It keeps the crypto exchange running stably, accurately, transparently and fits to diversified projects.</div>
      </div>
    </div>
    <div class="project__slide" data-aos="fade" data-aos-delay="500">
      <swiper :options="slideOption" class="project__slide-list">
        <swiper-slide class="list__item">
          <img src="/assets/images/project/timebird-exchange-01.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/timebird-exchange-02.png" alt="">
        </swiper-slide>
        <swiper-slide class="list__item">
          <img src="/assets/images/project/timebird-exchange-03.png" alt="">
        </swiper-slide>
        <div slot="pagination" class="swiper-pagination"></div>
      </swiper>
      <p data-aos="fade-up">TimeBird Exchange is a platform having 2 versions as web and mobile, on which traders conveniently make various crypto trading activities such as stop limit and future.</p>
      <a href="https://timebird.exchange/" target="_blank" data-aos="fade" data-aos-delay="300" class="link">Go to TimeBird Exchange</a>
    </div>
    <div class="project__feature pb0">
      <div class="container custom">
        <div class="project__feature-title" data-aos="fade-up">5 Why to choose TimeBird Exchange</div>
        <div class="project__feature-box">
          <div class="box__content">
            <template v-for="(item, index) in listFeature">
              <div class="box__content-list" data-aos="fade-right" :key="index">
                <div class="list__title" v-if="item.title">
                  <div class="icon">
                    <img src="/assets/images/layouts/icon-star.png" alt="icon">
                  </div>
                  {{ item.title }}
                </div>
                <template v-for="(_item, index) in item.listFeatureItem">
                  <div class="list__item" :key="index">
                    <div class="icon">
                      <img src="/assets/images/layouts/icon-bookmark.png" alt="icon">
                    </div>
                    {{ _item.title }}
                  </div>
                </template>
              </div>
            </template>
          </div>
          <div class="box__image" data-aos="fade-left">
            <img src="/assets/images/project/feature-image.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      active: 0,
      listFeature: [
        { title: '', listFeatureItem: [
          { title: 'Able to flexible customize as request' },
          { title: 'Reach processing speed up to 10,000 TPS' },
          { title: 'Enhance security by 2FA and eKYC ' },
          { title: 'Run stable with AWS' },
          { title: 'Offer the most reasonable cost' },
        ]},
      ],
      slideOption: {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slideToClickedSlide: true,
        speed: 800,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: -20,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false,
          scale: 0.8
        },
        breakpoints: {
          480: {
            slidesPerView: 2
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      }
    }
  },
  computed: {
    routeList () {
      return this.$route.matched
    }
  },
  methods: {
    next() {
      if (this.active++ > 1) this.active = 2;
    },
    prev() {
      if (this.active-- < 1) this.active = 0;
    },
  },
  created() {
    setTimeout(() => {
      AOS.refreshHard()
    }, 100) 
  }
}
</script>